module.exports = __webpack_public_path__ + "img/jc-icon@2x.f62a746f.png";